module.exports = __webpack_public_path__ + "static/media/0F611DF460814A5F9FE7A7AE42DF936B.a7f084ba.jpg";